import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  TimeBasedn2y4mla0fo0k as TimeBased,
  DateBasedu1hioe8kvjhw as DateBased,
  DayBased28hvf1xjg5r93 as DayBased,
  MonthBased16lxw4e6nhntg as MonthBased,
  DateTimeUnit3ugctnw90699o as DateTimeUnit,
} from '../DateTimeUnit.mjs';
import {
  MissingFieldException24tqif29emcmi as MissingFieldException,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.TimeBased', [], TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var elementName = 'nanoseconds';
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).az();
  $this$buildClassSerialDescriptor.g12(elementName, descriptor, annotations, false);
  return Unit_instance;
}
function TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw() {
  return (p0) => p0.az();
}
var TimeBasedDateTimeUnitSerializerClass;
function TimeBasedDateTimeUnitSerializer() {
  if (TimeBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        TimeBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.t24_1 = lazy(tmp_0, TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      az() {
        var tmp0 = this.t24_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw(), null);
        return tmp0.f2();
      }
      u24(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.az();
        var composite = encoder.l13(descriptor);
        composite.w14(TimeBasedDateTimeUnitSerializer_getInstance().az(), 0, value.d1n_1);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.u24(encoder, value instanceof TimeBased() ? value : THROW_CCE());
      }
      pz(decoder) {
        var seen = {_v: false};
        var nanoseconds = {_v: 0n};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.az();
        var composite = decoder.l13(descriptor);
        if (composite.a14()) {
          nanoseconds._v = composite.r13(TimeBasedDateTimeUnitSerializer_getInstance().az(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.b14(TimeBasedDateTimeUnitSerializer_getInstance().az());
            switch (elementIndex) {
              case 0:
                nanoseconds._v = composite.r13(TimeBasedDateTimeUnitSerializer_getInstance().az(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.m13(descriptor);
        if (!seen._v)
          throw MissingFieldException().g11('nanoseconds', this.az().h10());
        return new (TimeBased())(nanoseconds._v);
      }
    }
    initMetadataForObject($, 'TimeBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    TimeBasedDateTimeUnitSerializerClass = $;
  }
  return TimeBasedDateTimeUnitSerializerClass;
}
var TimeBasedDateTimeUnitSerializer_instance;
function TimeBasedDateTimeUnitSerializer_getInstance() {
  if (TimeBasedDateTimeUnitSerializer_instance === VOID)
    new (TimeBasedDateTimeUnitSerializer())();
  return TimeBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17($this) {
  var tmp0 = $this.v24_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs(), null);
  return tmp0.f2();
}
function DateBasedDateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateBased());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased()), getKClass(MonthBased())];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance()];
  return SealedClassSerializer().i10('kotlinx.datetime.DateTimeUnit.DateBased', tmp, tmp_0, tmp$ret$5);
}
function DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs() {
  return (p0) => _get_impl__d88w17(p0);
}
var DateBasedDateTimeUnitSerializerClass;
function DateBasedDateTimeUnitSerializer() {
  if (DateBasedDateTimeUnitSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      static w24() {
        DateBasedDateTimeUnitSerializer_instance = null;
        var $this = this.yz();
        DateBasedDateTimeUnitSerializer_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.v24_1 = lazy(tmp_0, DateBasedDateTimeUnitSerializer$impl$delegate$lambda);
        return $this;
      }
      rz(decoder, klassName) {
        return _get_impl__d88w17(this).rz(decoder, klassName);
      }
      x24(encoder, value) {
        return _get_impl__d88w17(this).tz(encoder, value);
      }
      tz(encoder, value) {
        return this.x24(encoder, value instanceof DateBased() ? value : THROW_CCE());
      }
      sz() {
        return getKClass(DateBased());
      }
      az() {
        return _get_impl__d88w17(this).az();
      }
    }
    initMetadataForObject($, 'DateBasedDateTimeUnitSerializer');
    DateBasedDateTimeUnitSerializerClass = $;
  }
  return DateBasedDateTimeUnitSerializerClass;
}
var DateBasedDateTimeUnitSerializer_instance;
function DateBasedDateTimeUnitSerializer_getInstance() {
  if (DateBasedDateTimeUnitSerializer_instance === VOID)
    DateBasedDateTimeUnitSerializer().w24();
  return DateBasedDateTimeUnitSerializer_instance;
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.DayBased', [], DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).az();
  $this$buildClassSerialDescriptor.g12('days', descriptor, annotations, false);
  return Unit_instance;
}
function DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3() {
  return (p0) => p0.az();
}
var DayBasedDateTimeUnitSerializerClass;
function DayBasedDateTimeUnitSerializer() {
  if (DayBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        DayBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.y24_1 = lazy(tmp_0, DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      az() {
        var tmp0 = this.y24_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3(), null);
        return tmp0.f2();
      }
      z24(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.az();
        var composite = encoder.l13(descriptor);
        composite.v14(DayBasedDateTimeUnitSerializer_getInstance().az(), 0, value.j1n_1);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.z24(encoder, value instanceof DayBased() ? value : THROW_CCE());
      }
      pz(decoder) {
        var seen = {_v: false};
        var days = {_v: 0};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.az();
        var composite = decoder.l13(descriptor);
        if (composite.a14()) {
          days._v = composite.q13(DayBasedDateTimeUnitSerializer_getInstance().az(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.b14(DayBasedDateTimeUnitSerializer_getInstance().az());
            switch (elementIndex) {
              case 0:
                days._v = composite.q13(DayBasedDateTimeUnitSerializer_getInstance().az(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.m13(descriptor);
        if (!seen._v)
          throw MissingFieldException().g11('days', this.az().h10());
        return new (DayBased())(days._v);
      }
    }
    initMetadataForObject($, 'DayBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    DayBasedDateTimeUnitSerializerClass = $;
  }
  return DayBasedDateTimeUnitSerializerClass;
}
var DayBasedDateTimeUnitSerializer_instance;
function DayBasedDateTimeUnitSerializer_getInstance() {
  if (DayBasedDateTimeUnitSerializer_instance === VOID)
    new (DayBasedDateTimeUnitSerializer())();
  return DayBasedDateTimeUnitSerializer_instance;
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.MonthBased', [], MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).az();
  $this$buildClassSerialDescriptor.g12('months', descriptor, annotations, false);
  return Unit_instance;
}
function MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn() {
  return (p0) => p0.az();
}
var MonthBasedDateTimeUnitSerializerClass;
function MonthBasedDateTimeUnitSerializer() {
  if (MonthBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        MonthBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.a25_1 = lazy(tmp_0, MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      az() {
        var tmp0 = this.a25_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn(), null);
        return tmp0.f2();
      }
      b25(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.az();
        var composite = encoder.l13(descriptor);
        composite.v14(MonthBasedDateTimeUnitSerializer_getInstance().az(), 0, value.k1n_1);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.b25(encoder, value instanceof MonthBased() ? value : THROW_CCE());
      }
      pz(decoder) {
        var seen = {_v: false};
        var months = {_v: 0};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.az();
        var composite = decoder.l13(descriptor);
        if (composite.a14()) {
          months._v = composite.q13(MonthBasedDateTimeUnitSerializer_getInstance().az(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.b14(MonthBasedDateTimeUnitSerializer_getInstance().az());
            switch (elementIndex) {
              case 0:
                months._v = composite.q13(MonthBasedDateTimeUnitSerializer_getInstance().az(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.m13(descriptor);
        if (!seen._v)
          throw MissingFieldException().g11('months', this.az().h10());
        return new (MonthBased())(months._v);
      }
    }
    initMetadataForObject($, 'MonthBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    MonthBasedDateTimeUnitSerializerClass = $;
  }
  return MonthBasedDateTimeUnitSerializerClass;
}
var MonthBasedDateTimeUnitSerializer_instance;
function MonthBasedDateTimeUnitSerializer_getInstance() {
  if (MonthBasedDateTimeUnitSerializer_instance === VOID)
    new (MonthBasedDateTimeUnitSerializer())();
  return MonthBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17_0($this) {
  var tmp0 = $this.c25_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateTimeUnitSerializer$_get_impl_$ref_2y1hvx(), null);
  return tmp0.f2();
}
function DateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateTimeUnit());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased()), getKClass(MonthBased()), getKClass(TimeBased())];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance(), TimeBasedDateTimeUnitSerializer_getInstance()];
  return SealedClassSerializer().i10('kotlinx.datetime.DateTimeUnit', tmp, tmp_0, tmp$ret$5);
}
function DateTimeUnitSerializer$_get_impl_$ref_2y1hvx() {
  return (p0) => _get_impl__d88w17_0(p0);
}
var DateTimeUnitSerializerClass;
function DateTimeUnitSerializer() {
  if (DateTimeUnitSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      static d25() {
        DateTimeUnitSerializer_instance = null;
        var $this = this.yz();
        DateTimeUnitSerializer_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.c25_1 = lazy(tmp_0, DateTimeUnitSerializer$impl$delegate$lambda);
        return $this;
      }
      rz(decoder, klassName) {
        return _get_impl__d88w17_0(this).rz(decoder, klassName);
      }
      e25(encoder, value) {
        return _get_impl__d88w17_0(this).tz(encoder, value);
      }
      tz(encoder, value) {
        return this.e25(encoder, value instanceof DateTimeUnit() ? value : THROW_CCE());
      }
      sz() {
        return getKClass(DateTimeUnit());
      }
      az() {
        return _get_impl__d88w17_0(this).az();
      }
    }
    initMetadataForObject($, 'DateTimeUnitSerializer');
    DateTimeUnitSerializerClass = $;
  }
  return DateTimeUnitSerializerClass;
}
var DateTimeUnitSerializer_instance;
function DateTimeUnitSerializer_getInstance() {
  if (DateTimeUnitSerializer_instance === VOID)
    DateTimeUnitSerializer().d25();
  return DateTimeUnitSerializer_instance;
}
function throwUnknownIndexException(index) {
  throw SerializationException().p10('An unknown field for index ' + index);
}
//region block: exports
export {
  DateBasedDateTimeUnitSerializer_getInstance as DateBasedDateTimeUnitSerializer_getInstance2rikesu6oglqz,
  DateTimeUnitSerializer_getInstance as DateTimeUnitSerializer_getInstance3b5n2mvis6ri5,
  DayBasedDateTimeUnitSerializer_getInstance as DayBasedDateTimeUnitSerializer_getInstance23o8q93ovx0p5,
  MonthBasedDateTimeUnitSerializer_getInstance as MonthBasedDateTimeUnitSerializer_getInstancecpechj7jc0xd,
  TimeBasedDateTimeUnitSerializer_getInstance as TimeBasedDateTimeUnitSerializer_getInstancewuqoobna26f2,
};
//endregion

//# sourceMappingURL=DateTimeUnitSerializers.mjs.map
